import { render, staticRenderFns } from "./VoigtDetail.vue?vue&type=template&id=38eeace7&"
import script from "./VoigtDetail.vue?vue&type=script&lang=js&"
export * from "./VoigtDetail.vue?vue&type=script&lang=js&"
import style0 from "./VoigtDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports